import { nsEnvelope } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.download_codes.created_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.updated_at',
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    ACCESS_CODE: {
        key: 'accessCode',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.access_code',
        placeholder: 'filter.placeholder.envelopes.access_code',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    DOWNLOAD_SERVER_IP_ADDRESS_PORT: {
        key: 'downloadServerIpAddressPort',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.server_ip',
        placeholder: 'filter.placeholder.envelopes.download_server_ip_address_port',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    SCHEDULED_START_DATE: {
        key: 'scheduledStartDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.schedule_start',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    SCHEDULED_END_DATE: {
        key: 'scheduledEndDate',
        type: FIELD_TYPES.DATE,
        entity: 'keys.envelopes.schedule_end',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: FILTER_TYPES.DATE
    },
    DOWNLOAD_CODE_NAME: {
        key: 'downloadCodeName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.envelopes.code_name',
        placeholder: 'filter.placeholder.download_codes.code_name',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    },
    CREATED_BY: {
        key: 'createdBy',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.download_codes.created_by',
        placeholder: 'filter.placeholder.download_codes.created_by',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: FILTER_TYPES.INPUT
    }
};